import React, { useState, useMemo, useCallback } from 'react';

import * as Yup from 'yup';

import { Report } from '~/components';
import { Autocomplete, RadioGroup } from '~/components/Form';
import { CUSTOMIZACAO_RAIZEN } from '~/constants/modules';
import { t, can } from '~/helpers';

function RelVeiculosAtivos() {
  const [open, setOpen] = useState(true);

  const options = useMemo(
    () => [
      { label: 'PDF', value: 'pdf' },
      { label: 'Excel', value: 'excel' },
    ],
    []
  );

  const onValidation = useCallback(async (values) => {
    try {
      const schema = Yup.object().shape({
        idposto: can(CUSTOMIZACAO_RAIZEN)
          ? Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string().nullable(),
      });

      await schema.validate(values, {
        abortEarly: false,
      });
    } catch (error) {
      const form = {};

      if (error instanceof Yup.ValidationError) {
        error.inner.forEach((err) => {
          form[err.path] = err.message.replace(`${err.path} `, '');
        });

        throw { form };
      }
    }
  }, []);

  const onSerialize = useCallback(
    (values) => ({
      ...values,
      idposto: values.idposto ?? '',
      codigonomeposto: values.codigonomeposto ?? '',
    }),
    []
  );

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.menu.relatorio.relveiculosativos')}
      relatorio="veiculosativos"
      initials={{ formato: 'pdf' }}
      validate={(values) => onValidation(values)}
      serialize={(values) => onSerialize(values)}
    >
      <Autocomplete
        name="idposto"
        label="codigonomeposto"
        url="postos"
        unique="idposto"
        hiddens={[{ name: 'codigonomeposto' }]}
        title={t('s.geral.postocomboio')}
      />

      <RadioGroup
        row
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={options}
        serialize={(value) => value}
      />
    </Report>
  );
}

export default RelVeiculosAtivos;
